import * as React from 'react';
import { SVGProps } from 'react';

const IconRUOSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 1a1 1 0 1 0 0 2v4L4.482 9.428l6.534-.802L10 7V3a1 1 0 1 0 0-2H6Zm5.601 8.562-7.8.957-1.653 2.645A1.2 1.2 0 0 0 3.165 15h9.67a1.2 1.2 0 0 0 1.017-1.836l-2.251-3.602ZM6 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm1.5-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM9 13.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2-.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
);
export default IconRUOSizeS;
